import React from 'react';
import { BaseButton, Typography } from 'fronton-react';
import { productName, productNameTextDefaultClass } from './styles';
import { cx } from 'linaria';

type ProductNameProps = {
  href: string;
  className?: string;
} & React.AnchorHTMLAttributes<HTMLButtonElement>;

export const ProductName: React.FC<ProductNameProps> = ({
  href,
  children,
  onClick,
  onMouseDown,
  className,
}) => {
  return (
    <BaseButton
      onClick={onClick}
      onMouseDown={onMouseDown}
      href={href}
      className={productName}
      data-qa="product-name"
    >
      <Typography
        variant={'s'}
        size={'body_short'}
        color="text-primary"
        className={cx(productNameTextDefaultClass, className)}
      >
        {children}
      </Typography>
    </BaseButton>
  );
};
